import { render } from "./FormInputPhoneField.vue?vue&type=template&id=720a7f32"
import script from "./FormInputPhoneField.vue?vue&type=script&lang=js"
export * from "./FormInputPhoneField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__